/**
 * TougeSupply — shared storefront interactions
 * Form validation, scroll behavior, editorial reveals and collection filters.
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. Quote Form Validation
     ========================================================================== */

  const quoteForm = document.getElementById('QuoteRequestForm');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function (e) {
      let isValid = true;
      const requiredFields = quoteForm.querySelectorAll('[required]');

      requiredFields.forEach(function (field) {
        const wrapper = field.closest('.quote-form__field');
        if (!wrapper) return;

        wrapper.classList.remove('quote-form__field--error');

        if (!field.value.trim()) {
          wrapper.classList.add('quote-form__field--error');
          isValid = false;
        }

        if (field.type === 'email' && field.value.trim()) {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(field.value.trim())) {
            wrapper.classList.add('quote-form__field--error');
            isValid = false;
          }
        }
      });

      if (!isValid) {
        e.preventDefault();
        const firstError = quoteForm.querySelector('.quote-form__field--error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    quoteForm.querySelectorAll('[required]').forEach(function (field) {
      field.addEventListener('input', function () {
        const wrapper = field.closest('.quote-form__field');
        if (wrapper) {
          wrapper.classList.remove('quote-form__field--error');
        }
      });
    });
  }

  /* ==========================================================================
     3. Smooth Scroll for Anchor Links
     ========================================================================== */

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#' || targetId === '') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ==========================================================================
     4. Intersection Observer — Fade-in on Scroll
     ========================================================================== */

  if ('IntersectionObserver' in window) {
    const fadeElements = document.querySelectorAll(
      '.car-specs__item, .quote-step'
    );

    if (fadeElements.length > 0) {
      fadeElements.forEach(function (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      });

      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      fadeElements.forEach(function (el) {
        observer.observe(el);
      });
    }
  }

  /* ==========================================================================
     Scroll reveals for editorial pages. Respects reduced motion.
     ========================================================================== */

  (function setupHomepageMotion() {
    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      return;
    }

    var STAGGER_MS = 70;
    var MAX_DELAY = 600;

    // Reveal elements used by the current editorial pages.
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('tsr-reveal');
    });

    // Any [data-reveal-group] wrapper — generic API for future sections.
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var children = group.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        child.classList.add('tsr-reveal');
        var delay = Math.min(i * STAGGER_MS, MAX_DELAY);
        child.style.setProperty('--ts-reveal-delay', delay + 'ms');
      }
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tsr-reveal--in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll('.tsr-reveal').forEach(function (el) {
      observer.observe(el);
    });
  })();

  /* ==========================================================================
     5. Pre-fill contact form from URL params (for car inquiries)
     ========================================================================== */

  const urlParams = new URLSearchParams(window.location.search);
  const carParam = urlParams.get('car');
  if (carParam) {
    const bodyField =
      document.querySelector('textarea[name="contact[body]"]') ||
      document.querySelector('textarea[name="contact[message]"]');
    if (bodyField && !bodyField.value) {
      var tsT = window.tsT || function (ns, key, fallback) { return fallback; };
      bodyField.value =
        tsT('quote', 'inquiry_body', 'I am interested in: [car]').replace('[car]', decodeURIComponent(carParam)) +
        '\n\n' +
        tsT('quote', 'inquiry_more', 'Please provide more information about this vehicle.');
    }

    const subjectField = document.querySelector('input[name="contact[subject]"]');
    if (subjectField && !subjectField.value) {
      subjectField.value = (window.tsT ? window.tsT('quote', 'inquiry_subject', 'Car Inquiry: [car]') : 'Car Inquiry: [car]').replace(
        '[car]',
        decodeURIComponent(carParam)
      );
    }
  }

  /* ==========================================================================
     6. Collection inventory — hide filters, reset
     ========================================================================== */

  (function setupCollectionInventory() {
    var wrapper = document.querySelector('.ts-collection-inventory');
    if (!wrapper) return;

    /* Hide / show sidebar filters (desktop). */
    var resultsBar = wrapper.querySelector('.facets-controls-wrapper.facets--horizontal');
    if (resultsBar && !resultsBar.querySelector('.ts-collection-hide-filters')) {
      var hideBtn = document.createElement('button');
      hideBtn.type = 'button';
      hideBtn.className = 'ts-collection-hide-filters button-unstyled';
      hideBtn.innerHTML =
        '<span class="ts-collection-hide-filters__icon" aria-hidden="true"></span>' +
        '<span class="ts-collection-hide-filters__label"></span>';

      var labelEl = hideBtn.querySelector('.ts-collection-hide-filters__label');

      function updateHideLabel() {
        var hidden = wrapper.classList.contains('ts-collection-inventory--filters-hidden');
        if (labelEl) {
          var tsT = window.tsT || function (ns, key, fallback) { return fallback; };
          labelEl.textContent = hidden
            ? tsT('collection', 'show_filters', 'Show filters')
            : tsT('collection', 'hide_filters', 'Hide filters');
        }
      }

      hideBtn.addEventListener('click', function () {
        wrapper.classList.toggle('ts-collection-inventory--filters-hidden');
        updateHideLabel();
        try {
          localStorage.setItem(
            'ts-filters-hidden',
            wrapper.classList.contains('ts-collection-inventory--filters-hidden') ? '1' : '0'
          );
        } catch (err) {
          /* localStorage unavailable */
        }
      });

      try {
        if (
          localStorage.getItem('ts-filters-hidden') === '1' &&
          window.matchMedia('(min-width: 750px)').matches
        ) {
          wrapper.classList.add('ts-collection-inventory--filters-hidden');
        }
      } catch (err) {
        /* localStorage unavailable */
      }

      updateHideLabel();
      resultsBar.insertBefore(hideBtn, resultsBar.firstChild);
    }
  })();

})();
